import * as React from 'react';
import { NavLink, Link } from 'react-router-dom';
import logo from '../../assets/logo_w.png';
import { withLocalize, Translate } from "react-localize-redux";
import LanguageToggle from '../languageToggle/LanguageToggle.jsx'
import './Nav.css';


class Nav extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      userMenuOpen: false
    };
  }


  toggleMenu() {
    this.setState({userMenuOpen: !this.state.userMenuOpen})
  }

  logout() {
      localStorage.setItem('account', "{}");
      let type = window.account.type
      window.account = {}
      this.props.history.push('/login/'+type)
    }

  public render() {
    return (

      <nav>
        <div className="profile">
          <div className="image" style={{backgroundImage: "url("+process.env.REACT_APP_AWS+"/"+window.account.type+"s/"+window.account.id+"/pictures/"+window.account.picture+")"}}></div>
          <span onClick={this.toggleMenu.bind(this)} className="name">{window.account.name} <i className="fas fa-angle-down"></i></span>
          <ul className={"userMenu " + (this.state.userMenuOpen? "open":"")}>
            <LanguageToggle />
            <Link to={"/admins/"+window.account.id}><Translate id="editProfile" /></Link>
            <li onClick={this.logout.bind(this)} style={{color: "#e13c34"}}><Translate id="logout" /></li>
          </ul>
        </div>
        <ul className="mainMenu">
          <NavLink activeClassName={"active"} to="/campaigns"><Translate id="campaigns" /></NavLink>
          {window.account.type == "admin" && <NavLink activeClassName={"active"} to="/users"><Translate id="influencers" /></NavLink>}
          {window.account.type == "admin" && <NavLink activeClassName={"active"} to="/clients"><Translate id="clients" /></NavLink>}
          {window.account.type == "admin" && <NavLink activeClassName={"active"} to="/admins"><Translate id="users" /></NavLink>}
        </ul>
        <img src={logo} />
      </nav>
    );
  }
}

export default withLocalize(Nav)



// WEBPACK FOOTER //
// ./src/_layout/nav/Nav.tsx